import { render, staticRenderFns } from "./LiteracyComponent1.vue?vue&type=template&id=2864b19c&scoped=true&"
import script from "./LiteracyComponent1.vue?vue&type=script&lang=js&"
export * from "./LiteracyComponent1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864b19c",
  null
  
)

export default component.exports